import React from 'react';
import Calculator from './components/Calculator';

function App() {
  return (
    <div className="app-container">
      <h1>IC Калкулатор</h1>
      <Calculator />
    </div>
  );
}

export default App;
